import React, { Component } from "react";
import Slider from "react-slick";
import "./home.css";

const sliderData = [
  {
    sliderSrc: "./Assets/slider_1.png",
    artistName: "@xander_hall",
    nftPrice: "16.5 ETH ",
  },
  {
    sliderSrc: "./Assets/slider_2.png",
    artistName: "@xander_hall",
    nftPrice: "16.5 ETH ",
  },
  {
    sliderSrc: "./Assets/slider_3.png",
    artistName: "@xander_hall",
    nftPrice: "16.5 ETH ",
  },
  {
    sliderSrc: "./Assets/slider_4.png",
    artistName: "@xander_hall",
    nftPrice: "16.5 ETH ",
  },
  {
    sliderSrc: "./Assets/slider_5.png",
    artistName: "@xander_hall",
    nftPrice: "16.5 ETH ",
  },
  {
    sliderSrc: "./Assets/slider_6.png",
    artistName: "@xander_hall",
    nftPrice: "16.5 ETH ",
  },
  {
    sliderSrc: "./Assets/slider_7.png",
    artistName: "@xander_hall",
    nftPrice: "16.5 ETH ",
  },
];

export default class CenterMode extends Component {
  render() {
    const settings = {
      className: "center",
      centerMode: true,
      infinite: true,
      slidesToShow: 6,
      speed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false,
            centerPadding: "10px",
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerPadding: "0px",
            centerMode: false,
          },
        },
      ],
    };
    return (
      <div>
        <h1 className="slider_heading">top artists</h1>
        <Slider autoplay={true} {...settings}>
          {sliderData.map((e) => {
            return (
              <div className="slider_div">
                <img src={e.sliderSrc} alt="" className="slider_images" />
                <h4 className="slider_name">{e.artistName}</h4>
                <h5 className="slider_price">{e.nftPrice}</h5>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  }
}
